import React, { useState, useEffect } from "react";
import { BusStudent, BusRoute, BusView, BusStudentCreate } from "../../api/BusService";
import { viewlist } from "../../api/BatchService";
import { student } from "../../api/StudentServices";
import Swal from "sweetalert2";

const BusStudentview = () => {
  const [BusStudentview, setBusStudentview] = useState([]);
  const [batches, setBatches] = useState([]);
  const [studentlist, setStudentlist] = useState([]);
  const [routes, setRoutes] = useState([]);
  const [buses, setBuses] = useState([]);
  const [error, setError] = useState([])
  const [selectedBatchId, setSelectedBatchId] = useState('');
  const [selectedStudentId, setSelectedStudentId] = useState('');
  const [searchBusId, setsearchBusId] = useState('');
  const [selectedRouteId, setSelectedRouteId] = useState('');
  const [busFees, setBusFees] = useState('');
  const [busFinalFees, setBusFinalFees] = useState('');
  const [busDiscount, setBusDiscount] = useState('');
  let activeToasts = [];

  function showCustomToast(message, type = "error") {
    const toast = document.createElement("div");
    toast.className = `custom-toast ${type}`;
    toast.innerText = message;

    // Calculate offset from bottom
    const gap = 10; // gap between toasts
    const toastHeight = 70; // estimated height
    const index = activeToasts.length;

    toast.style.bottom = `${1 + (index * (toastHeight + gap))}px`;

    document.body.appendChild(toast);
    activeToasts.push(toast);

    // Animate in
    setTimeout(() => {
      toast.classList.add("show");
    }, 10); // short delay for CSS transition

    // Auto remove
    setTimeout(() => {
      toast.classList.remove("show");
      setTimeout(() => {
        toast.remove();
        activeToasts = activeToasts.filter((t) => t !== toast);
        repositionToasts(); // adjust remaining toasts
      }, 300);
    }, 4000);
  }
  function repositionToasts() {
    const gap = 3;
    const toastHeight = 10;

    activeToasts.forEach((toast, index) => {
      toast.style.bottom = `${1 + (index * (toastHeight + gap))}px`;
    });
  }
  const Toast = Swal.mixin({
    toast: true,
    position: "bottom-end",
    showConfirmButton: false,
    timer: 2000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.onmouseenter = Swal.stopTimer;
      toast.onmouseleave = Swal.resumeTimer;
    },
  });

  const view = async () => {
    try {
      const response = await BusStudent();
      const buses = Array.isArray(response?.data?.data) ? response.data.data : ["this api data was not be fune]dejwnj"];

      const allStudentInfo = buses.flatMap((bus) =>
        (bus.students || []).map((student) => ({
          name: student.student_info?.name || "N/A",
          phone: student.student_info?.phone || "N/A",
          busId: student.bus_id || "N/A",
          joiningDate: student.created_at?.split("T")[0] || "N/A",
        }))
      );

      setBusStudentview(allStudentInfo);
    } catch (error) {
      const message =
        error?.response?.data?.message || error?.response?.message || error.message || "Something went wrong. Please try again.";
      showCustomToast(message, "error");
    }
  };


  const getBatchList = async () => {
    try {
      const response = await viewlist();
      setBatches(response.data?.batches || []);
    } catch {
      // Toast.fire({ icon: "error", title: "Data not found! batch" });
      const message = error?.response?.data?.message || error?.response?.message || error.message || "Something went wrong. Please try again.";
      showCustomToast(message, "error");
    }
  };

  const busView = async () => {
    try {
      const response = await BusView();
      setBuses(response.data?.data || []);
    } catch {
      // Toast.fire({ icon: "error", title: "Data not found! bus" });
      const message = error?.response?.data?.message || error?.response?.message || error.message || "Something went wrong. Please try again.";
      showCustomToast(message, "error");
    }
  };

  const fetchStudentsByBatch = async (batchId) => {
    try {
      if (!batchId) return setStudentlist([]);
      const response = await student(batchId);
      const allStudents = response?.data?.data?.data || [];
      setStudentlist(allStudents);
    } catch {
      // Toast.fire({ icon: "error", title: "Data not found! student" });
      const message = error?.response?.data?.message || error?.response?.message || error.message || "Something went wrong. Please try again.";
      showCustomToast(message, "error");
      setStudentlist([]);
    }
  };

  const handleBusChange = async (busId) => {
    setsearchBusId(busId);
    setRoutes([]);
    setSelectedRouteId('');
    setBusFees('');
    setBusFinalFees('');
    setBusDiscount('');

    try {
      const res = await BusRoute(busId);
      let routeList = res?.data?.data?.data || res?.data?.data || [];

      if (!Array.isArray(routeList)) {
        routeList = [routeList];
      }

      setRoutes(routeList);

      if (routeList.length > 0) {
        setSelectedRouteId(routeList[0].id.toString());
        setBusFees(routeList[0].route_fee || '');
      }
    } catch {
      // Toast.fire({ icon: "error", title: "Error fetching routes for selected bus" });
      const message = error?.response?.data?.message || error?.response?.message || error.message || "Something went wrong. Please try again.";
      showCustomToast(message, "error");
    }
  };

  const handleRouteChange = (routeId) => {
    setSelectedRouteId(routeId);
    const selected = routes.find(route => route.id.toString() === routeId.toString());
    setBusFees(selected?.route_fee || '');
  };

  useEffect(() => {
    const bus = parseFloat(busFees) || 0;
    const final = parseFloat(busFinalFees) || 0;
    if (final < bus) {
      setBusDiscount((bus - final).toFixed(2));
    } else {
      setBusDiscount("0");
    }
  }, [busFinalFees, busFees]);

  const Addstudent = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData(e.target);
      formData.set("bus_discount", busDiscount);
      const data = Object.fromEntries(formData.entries());
      const response = await BusStudentCreate(data)
      if (response.status === true) {
        Toast.fire({
          icon: 'success',
          title: 'Student Successfully Added'
        });
      }
    } catch {
      // Toast.fire({ icon: "error", title: "Error saving student" });
      const message = error?.response?.data?.message || error?.response?.message || error.message || error?.response?.message || "Something went wrong. Please try again.";
      showCustomToast(message, "error");
    }
  };

  useEffect(() => {
    view();
    getBatchList();
    busView();
  }, []);

  return (
    <>
      <div className=" mt-4">
        <h3 className="fw-bold text-primary mb-4">Bus Students</h3>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <strong className="fs-5">Students List</strong>
          <button className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#addinbus">
            + Add New Student
          </button>
        </div>

        <div className="mt-5">
          <div className="table-responsive">
            <table className="table table-bordered text-center">
              <thead className="table">
                <tr>
                  <th>#</th>
                  <th>Student Name</th>
                  <th>Mobile</th>
                  <th>Bus ID</th>
                  <th>Joining Date</th>
                </tr>
              </thead>
              <tbody>
                {BusStudentview.length > 0 ? (
                  BusStudentview.map((student, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{student.name}</td>
                      <td>{student.phone}</td>
                      <td>{student.busId}</td>
                      <td>{student.joiningDate}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5">No data available</td>
                  </tr>
                )}
                {/* <td>{JSON.stringify(BusStudentview)}</td> */}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Add Student Modal */}
      <div className="modal fade" id="addinbus" tabIndex={-1} aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <form onSubmit={Addstudent}>
              <div className="modal-header bg-label-primary text-white p-3">
                <h5 className="modal-title">Add Student</h5>
                <button type="button" className="btn-close" data-bs-dismiss="modal" />
              </div>
              <div className="modal-body">

                {/* Batch */}
                <div className="mb-3">
                  <label>Select Batch</label>
                  <select
                    name="batch_id"
                    className="form-control"
                    value={selectedBatchId}
                    onChange={(e) => {
                      const id = e.target.value;
                      setSelectedBatchId(id);
                      fetchStudentsByBatch(id);
                    }}
                  >
                    <option value="">Select Batch</option>
                    {batches.map(batch => (
                      <option key={batch.id} value={batch.id}>{batch.title}</option>
                    ))}
                  </select>
                </div>

                {/* Student */}
                <div className="mb-3">
                  <label>Select Student</label>
                  <select
                    name="student_id"
                    className="form-control"
                    value={selectedStudentId}
                    onChange={(e) => setSelectedStudentId(e.target.value)}
                    disabled={!selectedBatchId}
                  >
                    <option value="">Select Student</option>
                    {studentlist.map(student => (
                      <option key={student.id} value={student.id}>{student.name}</option>
                    ))}
                  </select>
                </div>

                {/* Bus */}
                <div className="mb-3">
                  <label>Select Bus</label>
                  <select
                    name="bus_id"
                    className="form-control"
                    value={searchBusId}
                    onChange={(e) => handleBusChange(e.target.value)}
                  >
                    <option value="">Select Bus</option>
                    {buses.map(bus => (
                      <option key={bus.id} value={bus.id}>{bus.bus_number}</option>
                    ))}
                  </select>
                </div>

                {/* Route */}
                <div className="mb-3">
                  <label>Select Route</label>
                  <select
                    name="route_id"
                    className="form-control"
                    value={selectedRouteId}
                    onChange={(e) => handleRouteChange(e.target.value)}
                  >
                    <option value="">Select Route</option>
                    {Array.isArray(routes) && routes.length > 0 ? (
                      routes.map((route) => (
                        <option key={route.id} value={route.id}>
                          {route.route_name}
                        </option>
                      ))
                    ) : (
                      <option disabled>No routes found</option>
                    )}
                  </select>
                </div>

                {/* Bus Fees */}
                <div className="mb-3">
                  <label>Bus Fees</label>
                  <input type="text" name="bus_fees" className="form-control" value={busFees} readOnly />
                </div>

                {/* Final Fees */}
                <div className="mb-3">
                  <label>Final Fees</label>
                  <input
                    type="number"
                    name="bus_final_fees"
                    className="form-control"
                    value={busFinalFees}
                    onChange={(e) => setBusFinalFees(e.target.value)}
                  />
                </div>

                {/* Discount */}
                <div className="mb-3">
                  <label>Discount</label>
                  <input
                    type="text"
                    name="bus_discount"
                    className="form-control"
                    value={busDiscount}
                    readOnly
                  />
                </div>

              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                <button type="submit" className="btn btn-primary">Save Student Detail</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default BusStudentview;
